import { defineStore } from 'pinia';

interface LoadingState {
  isLoading: boolean;
  message: string | null;
  counter: number;
}

export const useLoadingStore = defineStore('loading', {
  state: (): LoadingState => ({
    isLoading: false,
    message: null,
    counter: 0,
  }),
  actions: {
    show(message?: string) {
      this.counter++;
      this.isLoading = true;
      this.message = message ?? this.message;
      document.documentElement.style.overflow = 'hidden';
    },
    hide() {
      this.counter = Math.max(0, this.counter - 1);
      if (this.counter === 0) {
        this.isLoading = false;
        this.message = null;
        document.documentElement.style.overflow = '';
      }
    },
    reset() {
      this.counter = 0;
      this.isLoading = false;
      this.message = null;
      document.documentElement.style.overflow = '';
    },
    setMessage(message?: string | null) {
      this.message = message ?? null;
    },
  },
});
